<template>
  <ScrollTop v-if="showScrollTop" />
  <div class="englobe-params">
    <div class="params-row top">
      <h1 class="headline-small-regular">Nouveautés</h1>
      <FollawedRadioButtons
        all-match-route="/home"
        follawed-route="/home/follawed"
      />
    </div>
    <CheckBox
      :checked="isAllSelected"
      @update:checked="
        () => (isAllSelected ? unselectAllFilters() : selectAllFilters())
      "
    >
      Toutes les activités
    </CheckBox>
    <div class="params-row justify-start">
      <FilterCheckBox
        v-for="corpus in corpusFilters"
        :key="corpus.value"
        :label="corpus.label"
        :color="corpus.color"
        :item-count="store.itemsCounts[corpus.value]"
        :is-checked="store.selectedCorpuses.includes(corpus.value)"
        @check="addFilter(corpus.value)"
        @uncheck="removeFilter(corpus.value)"
      />
    </div>
    <div class="params-row">
      <SwitchSlide :is-active="!store.bypassQuery" @toggle="toggleUseRequest"
        >Utiliser la requête</SwitchSlide
      >
      <DropdownMenu
        v-model="selectedLimitOption"
        :options="limitOptions"
        label="Éléments par page :"
      />
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { storeToRefs } from "pinia";
import ScrollTop from "@follaw-fr/components/reusable/atoms/ScrollTop.vue";
import CheckBox from "@follaw-fr/components/reusable/atoms/CheckBox.vue";
import FollawedRadioButtons from "@/follaw-fr/components/reusable/atoms/FollawedRouterRadioButtons.vue";
import FilterCheckBox from "@follaw-fr/components/reusable/atoms/FilterCheckBox.vue";
import SwitchSlide from "@follaw-fr/components/reusable/atoms/SwitchSlide.vue";
import { useHomepageStore } from "@follaw-fr/stores/homepage";
import DropdownMenu from "@follaw-fr/components/reusable/atoms/DropdownMenu.vue";
import { useDropdown } from "@follaw-fr/composables/useDropdown";

const store = useHomepageStore();
const { basePayload } = storeToRefs(store);

const showScrollTop = computed(() => basePayload.value.size > 20);

const fetchHomepage = () => {
  basePayload.value.from = 0;
  store.fetchHomepage();
};

const { options: limitOptions, selectedValue: selectedLimitOption } =
  useDropdown({
    options: { 10: "10", 20: "20", 50: "50", 200: "200" },
    selectedFilters: basePayload,
    filterKey: "size",
    onChange: () => {
      fetchHomepage();
    },
  });

const corpusFilters = [
  {
    label: "Dossiers Législatifs",
    color: "var(--clr-service-legidoc)",
    value: store.CORPUSES.LEGIDOCS,
  },
  {
    label: "JORF",
    color: "var(--clr-service-jorf)",
    value: store.CORPUSES.JORFS,
  },
  {
    label: "Amendements",
    color: "var(--clr-service-amendment)",
    value: store.CORPUSES.AMENDMENTS,
  },
  {
    label: "Questions",
    color: "var(--clr-service-question)",
    value: store.CORPUSES.QUESTIONS,
  },
  {
    label: "Comptes-rendus",
    color: "var(--clr-service-report)",
    value: store.CORPUSES.REPORTS,
  },
  {
    label: "Publications",
    color: "var(--clr-service-twitter)",
    value: store.CORPUSES.POSTS,
  },
  // <!--TODO : uncomment once back is fixed (receive news with type "article")
  // {
  //   label: "Articles",
  //   color: "var(--clr-service-article)",
  //   value: store.CORPUSES.ARTICLES,
  // },
  {
    label: "Nominations",
    color: "var(--clr-service-nominations)",
    value: store.CORPUSES.NOMINATIONS,
  },
  {
    label: "Agenda",
    color: "var(--clr-service-agenda)",
    value: store.CORPUSES.AGENDA,
  },
  {
    label: "Communiqués",
    color: "var(--clr-service-news)",
    value: store.CORPUSES.NEWS,
  },
];

const addFilter = (filter) => {
  store.selectedCorpuses.push(filter);
  fetchHomepage();
};

const removeFilter = (filter) => {
  store.selectedCorpuses = store.selectedCorpuses.filter((f) => f !== filter);
  fetchHomepage();
};

const selectAllFilters = () => {
  store.selectedCorpuses = Object.values(store.CORPUSES);
  fetchHomepage();
};

const unselectAllFilters = () => {
  store.selectedCorpuses = [];
  fetchHomepage();
};

const isAllSelected = computed(
  () => store.selectedCorpuses.length === Object.keys(store.CORPUSES)?.length
);

const toggleUseRequest = () => {
  store.bypassQuery = !store.bypassQuery;
  fetchHomepage();
};
</script>

<style lang="scss" scoped>
.justify-start {
  justify-content: start;
}
</style>
